import React from 'react'

/**
 * 標題允許的行內標記，`InkHero`／`SectionHead` 共用一份。
 *
 * `<ph>` 是片語（inline-block，放得下就整段不拆）、`<br/>` 指定斷行、
 * `<em>` 是重點（品牌紅底線，**不是斜體**——中文字型沒有斜體字面，瀏覽器會
 * 硬斜，字重還會掉一階，看起來像換了一套字）。
 */
export const TITLE_COMPONENTS = {
  ph: <span className="inline-block" />,
  em: (
    <em className="font-[inherit] underline decoration-brand decoration-[0.06em] underline-offset-[0.14em] not-italic [text-decoration-skip-ink:none]" />
  ),
}
